import type { NDParamsType } from 'commons'
import { splittingString } from 'commons/utils/string'
import { YesNo } from 'constants/enums'
import { statusNegDiffApproval } from 'services/nd/constants'

const formatStatus = (status: string) => {
  return splittingString(status).map((item) =>
    item === 'Aprovado' ? statusNegDiffApproval.backOffice : statusNegDiffApproval.pending,
  )
}

const formatCausa = (causa: string) => {
  return splittingString(causa).map((item) => {
    if (item === 'Prazo') return 'C'
    else if (item === 'Desconto') return 'D'
    else if (item === 'Bonificação') return 'B'
    else return 'A'
  })
}

const formatTiposMaterial = (tiposMaterial: string) => {
  return splittingString(tiposMaterial).map((item) => {
    if (item === 'Fora de linha') return YesNo.YES
    else return YesNo.NO
  })
}

const formatTiposOV = (tiposOV: string) => {
  return splittingString(tiposOV).map((item) => item.split(' - ')[0])
}

const formatMesCota = (mesCotas: string) => {
  const selectedOptions = splittingString(mesCotas).sort()

  return selectedOptions.map((item) => {
    const year = item.split('/')[1]
    const month = item.split('/')[0]
    return `${year}${month}`
  })
}

export const formattingNDPayload = (data: NDParamsType) => ({
  ...data,
  causas: formatCausa(data.causas),
  codigosEquipeVenda: splittingString(data.codigosEquipeVenda)?.map((item) => item.substring(0, 3)),
  codigosRegiaoVenda: splittingString(data.codigosRegiaoVenda)?.map((item) => item.substring(0, 6)),
  codigosSapCliente: splittingString(data.codigosSapCliente),
  escritoriosVenda: splittingString(data.escritoriosVenda),
  hierarquiaCliente: data.hierarquiaCliente === 'true',
  mesesCota: formatMesCota(data.mesesCota),
  numerosOrdemVenda: splittingString(data.numerosOrdemVenda),
  numerosOrdemVendaSap: splittingString(data.numerosOrdemVendaSap),
  razoesSociaisCliente: splittingString(data.razoesSociaisCliente),
  statusAprovacao: formatStatus(data.statusAprovacao),
  tiposMaterial: formatTiposMaterial(data.tiposMaterial),
  tiposOrdemVenda: formatTiposOV(data.tiposOrdemVenda),
})
